import { getValue } from '../utility/helpers';
import Main from '../components/admin/tiers/Main';
import { USER_TYPE } from '../enums/applicationEnums';
import withAuth from '../utility/withAuth';

const AdminTiers = () => {
    const userRole = getValue('userType');

    if (userRole !== USER_TYPE.ADMIN) {
        return null;
    }
    return (
        <>
            <Main />
        </>
    );
};

export default withAuth(AdminTiers);
